module.exports = __webpack_public_path__ + "img/human meditation_elements.jpg";